export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-white/50 text-sm mb-8">Last updated: {new Date().toLocaleDateString()}</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Acceptance</h2>
        <p className="text-white/80 leading-relaxed">
          By signing in to Setback you agree to these Terms and to the Privacy Policy. If you do not agree, do not
          use the app.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Acceptable use</h2>
        <p className="text-white/80 leading-relaxed">
          You agree not to: cheat or use automated tools to play on your behalf; harass, threaten, or impersonate
          other users; use offensive screen names; attempt to access accounts or data that are not yours; or use
          Setback for any unlawful purpose. We reserve the right to suspend or terminate accounts that violate
          these rules.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. Your content</h2>
        <p className="text-white/80 leading-relaxed">
          You are responsible for your screen name and any actions taken by your account. You grant us permission
          to display your screen name to other players at your table, and to store your gameplay data as described
          in the Privacy Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Termination</h2>
        <p className="text-white/80 leading-relaxed">
          You may delete your account at any time from profile settings. We may suspend or terminate accounts that
          violate these Terms, and may discontinue the service at any time with reasonable notice.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Disclaimers</h2>
        <p className="text-white/80 leading-relaxed">
          Setback is provided "as is" without warranties of any kind. We do not guarantee uninterrupted access,
          error-free operation, or that bugs will be fixed. Play is intended for entertainment; no prizes or real
          money are awarded.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Limitation of liability</h2>
        <p className="text-white/80 leading-relaxed">
          To the fullest extent permitted by law, Setback and its owner are not liable for any indirect,
          incidental, or consequential damages arising from your use of the app.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Governing law</h2>
        <p className="text-white/80 leading-relaxed">
          These Terms are governed by the laws of the State of Connecticut, United States. Any disputes will be
          resolved in courts located in Connecticut.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Changes</h2>
        <p className="text-white/80 leading-relaxed">
          We may update these Terms occasionally. If changes are material, we will prompt you to re-accept them
          the next time you sign in.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">9. Contact</h2>
        <p className="text-white/80 leading-relaxed">
          Questions or disputes: nickbauer540@gmail.com
        </p>
      </section>

      {/* Note to app owner: This is a lightweight indie-friendly template.
          If Setback expands beyond family and friends, have an attorney review
          this document before shipping publicly. */}
    </div>
  );
}
